import typography from 'shared-tokens/utils/tokens/typography';

export const mainCls = 'tooltip-qrcode';

export default {
  [`${mainCls}`]: {
    position: 'absolute',
    top: '54px',
    right: '6px',
    color: 'white',
    minWidth: '100px',
    visibility: 'hidden',
    opacity: 0,
    padding: '16px',
    borderRadius: '4px',
    border: '2px solid #1A1F24',
    background: '#fff',
    transition: 'opacity 0.3s ease-in-out',
    zIndex: 7,
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '-9px',
      right: '10px',
      width: '0',
      height: '0',
      borderLeft: '9px solid transparent',
      borderRight: '9px solid transparent',
      borderBottom: '8px solid #1A1F24',
    },
    '&::before': {
      content: '""', 
      position: 'absolute',
      top: '-7px',
      right: '12px',
      width: '0',
      height: '0',
      borderLeft: '7px solid transparent',
      borderRight: '7px solid transparent',
      borderBottom: '7px solid #fff',
      zIndex: 1,
    }
  },
  [`${mainCls}__visible`]: {
    visibility: 'visible',
    opacity: 1,
  },
  [`${mainCls}__upper_cnt`]: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '8px',
  },
  [`${mainCls}__header_close`]: {
    color: '#1A1F24 !important',
    cursor: 'pointer',
  },
  [`${mainCls}__text`]: {
    display: 'flex',
    width: '18px',
    height: '18px',
    flexDirection: 'row-reverse',
    border: '2px solid #fff', 
    borderRadius: '50%',
    padding: '2px',
    margin: '-2px',
    alignItems: 'center',
    '& path': {
      strokeWidth: '2',
    },
    '&:hover': {
      border: '2px solid #F8F9FA',
      color: '#1A1F24 !important',
      backgroundColor: 'rgba(57, 67, 78, 0.08)', 
    },
    '&:active': {
      border: '2px solid #F0F2F5',
      color: '#96A1B0 !important',
    },
    
  },
};
